var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-edit-layout',[_c('v-col',[_c('route-form',{attrs:{"id":_vm.id,"title":_vm.title,"item":_vm.item}}),(this.item != null)?_c('div',[_c('ListPath',{attrs:{"route_id":_vm.id}})],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }